import { render, staticRenderFns } from "./OptionMappingSetting.vue?vue&type=template&id=4bf2709c&scoped=true"
import script from "./OptionMappingSetting.vue?vue&type=script&lang=js"
export * from "./OptionMappingSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf2709c",
  null
  
)

export default component.exports